import React from "react";
import PropTypes from "prop-types";
import { withNamespaces } from "react-i18next";
import classNames from "classnames";
import { Colors } from "../../../shared/config";

const ProductType = PropTypes.shape({
  sku: PropTypes.string,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  image: PropTypes.string,
  url: PropTypes.url,
  video: PropTypes.video,
  wishlisted: PropTypes.bool
});

const IconButton = props => {
  return (
    <a
      role="button"
      href="#action"
      className="button-icon-wrap"
      onClick={props.onPress}
    >
      <i className={props.iconName} style={{ color: props.iconColor }} />
      <span className="button-icon-label">{props.label}</span>
    </a>
  );
};

const Product = props => {
  return (
    <div
      className={classNames(
        "product-container",
        props.compact ? "compact" : {}
      )}
    >
      <div className="background-wrap">
        <div className="product-wrap">
          <div className="product-image">
            <img
              alt={props.product.name}
              src={props.product.image}
              style={{
                width: props.compact ? 75 : 100,
                height: props.compact ? 86 : 115
              }}
            />
          </div>
          <div className="product-content">
            <span className="product-name">{props.product.name}</span>
            <span className="product-sku">{props.product.sku}</span>

            <div className="product-actions">
              <IconButton
                iconName="icon-heart"
                iconColor={
                  props.product.wishlisted ? Colors.HWK_RED : Colors.GREY_3
                }
                label={props.t("products:button_wishlist")}
                onPress={event => {
                  event.preventDefault();
                  props.onToggleWishlist(props.product);
                }}
              />
              {props.product.video && (
                <IconButton
                  iconName="icon-youtube"
                  iconColor={Colors.GREY_3}
                  label={props.t("products:button_video")}
                  onPress={event => {
                    event.preventDefault();
                    props.onOpenVideo(props.product);
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="buy-product-wrap">
        <a
          role="button"
          href="#buy-product"
          className="buy-button"
          onClick={event => {
            event.preventDefault();
            props.onBuyProduct(props.product);
          }}
        >
          <i className="icon-cart" />
          <span className="buy-button-label">
            {props.t("products:button_buynow")}
          </span>
        </a>
      </div>
    </div>
  );
};

Product.propTypes = {
  product: ProductType.isRequired,
  compact: PropTypes.bool,
  onToggleWishlist: PropTypes.func,
  onOpenVideo: PropTypes.func,
  onBuyProduct: PropTypes.func
};

Product.defaultProps = {
  compact: false,
  onToggleWishlist: () => {},
  onOpenVideo: () => {},
  onBuyProduct: () => {}
};

export default withNamespaces(["products", "common"], { wait: true })(Product);
